import { Languages } from "src/common/descriptions/types";
import { UsersDescriptions } from "./types";

const DescriptionsEnUs: UsersDescriptions = {
    TITLE: "Users",
    TABLE: {
        ACTION_BUTTON: "Create User",
        SEARCH_PLACEHOLDER: "Search User",
        LOADING_DATA: "Loading data...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        NAME: "Name",
        SURNAME: "Surname",
        LAST_LOGIN: "Last Login",
        USER_ROLE: "User Role",
        STATUS: "Status",
        ACTIONS: "Actions",
    },
    ROLES: {
        ADMIN: "Admin",
        MANAGER: "Manager",
    },
}

const DescriptionsEsUs: UsersDescriptions = {
    TITLE: "Usuarios",
    TABLE: {
        ACTION_BUTTON: "Crear Usuario",
        SEARCH_PLACEHOLDER: "Buscar Usuario",
        LOADING_DATA: "Cargando datos...",
    },
    TABLE_COLUMNS: {
        ID: "No",
        NAME: "Nombres",
        SURNAME: "Apellidos",
        LAST_LOGIN: "Último acceso",
        USER_ROLE: "Rol",
        STATUS: "Estado",
        ACTIONS: "Acciones",
    },
    ROLES: {
        ADMIN: "Administrador",
        MANAGER: "Gestor de Cobros",
    },
}

export const usersDictionary = {
    [Languages.ENGLISH_US]: DescriptionsEnUs,
    [Languages.SPANISH_US]: DescriptionsEsUs,
}